import { Injectable } from "@angular/core";
import { api } from "../../environments/environment";
import { RestService } from "./rest.service";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  constructor(private rest: RestService) {}

  getMe() {
    return this.rest.get(api.endpoint.me);
  }

  changePassword(data: any) {
    return this.rest.put(api.endpoint.changePassword, data);
  }
}
